import { CommonUtilities } from '../../../commonUtils';

export default class assetsCompareServices {


    public static assetsCompareMenu = [
        /*{
            title: 'Detail Assets Compare',
            route: 'assetCompare'
        },*/
        {
            title: 'Assets Compare',
            route: 'assetCompare'
        }, {
            title: 'Trend Compare',
            route: 'trendCompare'
        },
        {
            title: 'Portal Assets',
            route: 'adminAssets'
        }, /*{
            title: 'Asset Trend',
            route: 'AssetTrend'
        }, {
            title: 'Contract Trend',
            route: 'ContractTrend'
        }*/
        , {
            title: 'Korrect Trend',
            route: 'KorrectTrend'
        }
        , {
            title: 'Korrect Delivery',
            route: 'KorrectDelivery'
        }/*, {
            title: 'Asset Upload',
            route: 'assetUpload'
        }*/
    ]

    static getAssetCompare(param: any) {
        var url = 'MainAsset/AssetComparison';
        return CommonUtilities.postData(url, param);
    }


    static getMinimumSetAssetCompare(param: any) {
        var url = 'MainAsset/AssetComparison/MinimumSet';
        return CommonUtilities.postData(url, param);
    }

    static exportAssetCompare(param: any) {
        var url = 'MainAsset/AssetComparison/export';
        return CommonUtilities.postExport(url, param, param?.ExportType ? param.ExportType : "Export");
    }

    static AssetComparisonMinSetExport(param: any) {
        var url = 'MainAsset/AssetComparison/MinimumSet/export';
        return CommonUtilities.postExport(url, param, param?.ExportType ? param.ExportType : "Export");
    }

    static korrectUpdateAssetCompare(param: any) {
        var url = 'MainAsset/AssetComparison/korrectUpdate';
        return CommonUtilities.postData(url, param);
    }

    static exportPhyAssetCompare(param: any) {
        var url = 'MainAsset/AssetComparison/exportPhysical';
        return CommonUtilities.postExport(url, param, "Export");
    }

    static trendsAnalysis(param: any) {
        var url = 'contracts/analytics/trendsAnalysis';
        return CommonUtilities.postData(url, param);
    }

    static KorrectReleaseTrackList(param: any) {
        var url = 'MusicDirectory/KorrectReleaseTrackList/all';
        return CommonUtilities.postData(url, param);
    }

    static KorrectSongListList(param: any) {
        var url = 'MusicDirectory/KorrectSongList/all';
        return CommonUtilities.postData(url, param);
    }

    static trackReleaseMin(param: any) {
        var url = 'MusicDirectory/assetUploader/trackRelease/listing/all';
        return CommonUtilities.postData(url, param);
    }


    static KorrectReleaseTrackListExport(param: any) {
        var url = 'MusicDirectory/KorrectReleaseTrackList/all';
        return CommonUtilities.postData(url, param);
    }

    static trackReleaseMinExport(param: any) {
        var url = 'MusicDirectory/assetUploader/releaseTrack/Export';
        return CommonUtilities.postData(url, param);
    }

    static excelGenericExport(data: any) {
        const url = 'CrystalReport/excelGeneric/export?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', 'excelGenericExport');
    };

    static trendCompare(data: any) {
        const url = 'MusicDirectory/trendCompare';
        return CommonUtilities.postData(url, data);
    };

    static trendCompareExport(data: any) {
        const url = 'MusicDirectory/trendCompareExport';                  
        return CommonUtilities.postExport(url, data, "trendCompareExport");
    };

    static trendCompareDetail(data: any) {
        const url = 'MusicDirectory/trendCompareDetail';  
        return CommonUtilities.postData(url, data);
    };


    static portalApiListing(data: any) {
        const url = 'MusicDirectory/portalAsset/listing';
        return CommonUtilities.postData(url, data);
    };

}